import Vue from "vue";
import locale from "element-ui/lib/locale";
import VueI18n from "vue-i18n";
import cn from "./langs/cn";
import es from "./langs/es";
import en from "./langs/en";
import vi from "./langs/vi";
import id from "./langs/id";
import ar from "./langs/ar";
import { arrayOrNull } from "@/utils";
// const (
// LANG_ZH = "zh-CN"
// LANG_EN = "en-US"
// LANG_ID = "id-ID"
// LANG_MX = "es-MX"
// )
const messages = {
  "zh-CN": cn,
  "es-MX": es,
  "en-US": en,
  "vi-VN": vi,
  "id-ID": id,
  "ar-AR": ar,
};
Vue.use(VueI18n);
// <!--temporary hidden-->
let _lang: any = "en-US";
if (localStorage.getItem("cn")) {
  _lang = localStorage.getItem("cn");
}
const i18n = new VueI18n({
  locale: _lang, // 设置默认语言
  messages
});

locale.i18n((key: any, value: any) => i18n.t(key, value)); //为了实现element插件的多语言切换
export default i18n;
